import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  podcasters: [],
  loading: false,
  error: null,
  pagination: { totalDocs: 0, page: 1, limit: 10 },
};

// ============ THUNKS ============
export const fetchPodcaster = createAsyncThunk(
  'podcaster/fetch',
  async ({ fetchType="table", page, limit, search } = {}, { rejectWithValue }) => {
    try {
      const params = { ...(fetchType && { fetchType }), ...(page && { page }), ...(limit && { limit }), ...(search && { search }) };
      const response = await axiosInstance.get('/api/admin/podcasters', { params });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch podcasters');
    }
  }
);

export const createPodcaster = createAsyncThunk(
  'podcaster/create',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/admin/podcasters', formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to create podcaster');
    }
  }
);

export const updatePodcaster = createAsyncThunk(
  'podcaster/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/podcasters/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to update podcaster');
    }
  }
);

export const deletePodcaster = createAsyncThunk(
  'podcaster/delete',
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/podcasters/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to delete podcaster');
    }
  }
);

// ============ SLICE ============
const PodcasterSlice = createSlice({
  name: 'podcasters',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPodcaster.pending, (state) => { state.loading = true; })
      .addCase(fetchPodcaster.fulfilled, (state, action) => {
        state.loading = false;
        state.podcasters = action.payload?.data.records || [];
        state.pagination = action.payload?.data?.pagination || action.payload?.pagination || initialState.pagination;
      })
      .addCase(fetchPodcaster.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createPodcaster.fulfilled, (state, action) => { state.podcasters.push(action.payload); })
      .addCase(updatePodcaster.fulfilled, (state, action) => {
        state.podcasters = state.podcasters.map(c => c._id === action.payload._id ? action.payload : c);
      })
      .addCase(deletePodcaster.fulfilled, (state, action) => {
        state.podcasters = state.podcasters.filter(c => c._id !== action.payload);
      });
  },
});

export default PodcasterSlice.reducer;
